/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The StatisticsSummaryUserData model module.
 * @module model/StatisticsSummaryUserData
 * @version 1.0
 */
class StatisticsSummaryUserData {
    /**
     * Constructs a new <code>StatisticsSummaryUserData</code>.
     * @alias module:model/StatisticsSummaryUserData
     */
    constructor() { 
        
        StatisticsSummaryUserData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StatisticsSummaryUserData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StatisticsSummaryUserData} obj Optional instance to populate.
     * @return {module:model/StatisticsSummaryUserData} The populated <code>StatisticsSummaryUserData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StatisticsSummaryUserData();

            if (data.hasOwnProperty('signinUserCount')) {
                obj['signinUserCount'] = ApiClient.convertToType(data['signinUserCount'], 'Number');
            }
            if (data.hasOwnProperty('signinHolderCount')) {
                obj['signinHolderCount'] = ApiClient.convertToType(data['signinHolderCount'], 'Number');
            }
            if (data.hasOwnProperty('totalUserCount')) {
                obj['totalUserCount'] = ApiClient.convertToType(data['totalUserCount'], 'Number');
            }
            if (data.hasOwnProperty('newUserCount')) {
                obj['newUserCount'] = ApiClient.convertToType(data['newUserCount'], 'Number');
            }
            if (data.hasOwnProperty('activatedUserCount')) {
                obj['activatedUserCount'] = ApiClient.convertToType(data['activatedUserCount'], 'Number');
            }
            if (data.hasOwnProperty('totalHolderCount')) {
                obj['totalHolderCount'] = ApiClient.convertToType(data['totalHolderCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>StatisticsSummaryUserData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>StatisticsSummaryUserData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} signinUserCount
 */
StatisticsSummaryUserData.prototype['signinUserCount'] = undefined;

/**
 * @member {Number} signinHolderCount
 */
StatisticsSummaryUserData.prototype['signinHolderCount'] = undefined;

/**
 * @member {Number} totalUserCount
 */
StatisticsSummaryUserData.prototype['totalUserCount'] = undefined;

/**
 * @member {Number} newUserCount
 */
StatisticsSummaryUserData.prototype['newUserCount'] = undefined;

/**
 * @member {Number} activatedUserCount
 */
StatisticsSummaryUserData.prototype['activatedUserCount'] = undefined;

/**
 * @member {Number} totalHolderCount
 */
StatisticsSummaryUserData.prototype['totalHolderCount'] = undefined;






export default StatisticsSummaryUserData;

